<script>
    export let Title;
    export let subTitle;
    export let textButton;
    export let img = '';
    export let link = '#';
</script>


<component editor-editable="true">
    <style>
        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc SECTION.section.bg-video {
            background-color: #fff;
            color: #212529;
            font-family: 'Nunito', sans-serif;
            line-height: 1.5;
            text-align: left;
            -webkit-tap-highlight-color: transparent;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc * {
            box-sizing: border-box;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc ::after {
            box-sizing: border-box;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc ::before {
            box-sizing: border-box;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc section {
            display: block;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc h3 {
            margin-top: 0;
            margin-bottom: .5rem;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc p {
            margin-top: 0;
            margin-bottom: 1rem;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc a {
            color: #007bff;
            text-decoration: none;
            background-color: transparent;
            -webkit-text-decoration-skip: objects;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc a:hover {
            color: #0056b3;
            text-decoration: underline;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc h3 {
            margin-bottom: .5rem;
            font-family: 'Nunito', sans-serif;
            font-weight: 500;
            line-height: 1.2;
            color: #212529;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc h3 {
            font-size: 1.75rem;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc .container {
            width: 100%;
            padding-right: 15px;
            padding-left: 15px;
            margin-right: auto;
            margin-left: auto;
        }

        @media (min-width: 576px) {
            .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc .container {
                max-width: 540px;
            }
        }

        @media (min-width: 768px) {
            .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc .container {
                max-width: 720px;
            }
        }

        @media (min-width: 992px) {
            .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc .container {
                max-width: 960px;
            }
        }

        @media (min-width: 1200px) {
            .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc .container {
                max-width: 1140px;
            }
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc .row {
            display: -ms-flexbox;
            display: flex;
            -ms-flex-wrap: wrap;
            flex-wrap: wrap;
            margin-right: -15px;
            margin-left: -15px;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc .col-lg-12 {
            position: relative;
            width: 100%;
            min-height: 1px;
            padding-right: 15px;
            padding-left: 15px;
        }

        @media (min-width: 992px) {
            .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc .col-lg-12 {
                -ms-flex: 0 0 100%;
                flex: 0 0 100%;
                max-width: 100%;
            }
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc .mb-0 {
            margin-bottom: 0 !important;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc .mt-2 {
            margin-top: .5rem !important;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc .mt-4 {
            margin-top: 1.5rem !important;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc .pt-4 {
            padding-top: 1.5rem !important;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc .mx-auto {
            margin-right: auto !important;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc .mx-auto {
            margin-left: auto !important;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc .text-center {
            text-align: center !important;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc .text-capitalize {
            text-transform: capitalize !important;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc .font-weight-bold {
            font-weight: 700 !important;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc .text-white {
            color: #fff !important;
        }

        @media print {
            .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc * {
                text-shadow: none !important;
                box-shadow: none !important;
            }

            .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc ::after {
                text-shadow: none !important;
                box-shadow: none !important;
            }

            .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc ::before {
                text-shadow: none !important;
                box-shadow: none !important;
            }

            .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc a:not(.btn) {
                text-decoration: underline;
            }

            .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc h3 {
                orphans: 3;
                widows: 3;
            }

            .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc p {
                orphans: 3;
                widows: 3;
            }

            .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc h3 {
                page-break-after: avoid;
            }

            .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc .container {
                min-width: 992px !important;
            }
        }

        /*! CSS Used from: http://themesboss.com/brezon/css/materialdesignicons.min.css*/
        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc .mdi:before {
            display: inline-block;
            font: normal normal normal 24px/1 "Material Design Icons";
            font-size: inherit;
            text-rendering: auto;
            line-height: inherit;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc .mdi-play:before {
            content: "\F40A";
        }

        /*! CSS Used from: http://themesboss.com/brezon/css/style.css*/
        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc h3 {
            font-family: 'Nunito', sans-serif;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc a {
            text-decoration: none !important;
            outline: none !important;
            box-shadow: none !important;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc a:hover {
            text-decoration: none !important;
            outline: none !important;
            box-shadow: none !important;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc a:focus {
            text-decoration: none !important;
            outline: none !important;
            box-shadow: none !important;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc ::selection {
            background: rgba(166, 175, 189, 0.3);
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc ::-moz-selection {
            background: rgba(166, 175, 189, 0.3);
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc .section {
            padding-top: 80px;
            padding-bottom: 80px;
            position: relative;
            background-color: #fff;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc .main-title-border {
            background-color: red;
            height: 2px;
            width: 60px;
            margin: 15px 0px;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc .sec_subtitle {
            max-width: 600px;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc .bg-overlay {
            background: rgba(27, 31, 37, 0.8);
            position: absolute;
            top: 0;
            right: 0;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 100%;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc .bg-video {
            background-size: cover;
            background-position: center center;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc .video-btn-white a {
            border: 2px solid #fff;
            padding: 4px 15px 4px 5px;
            border-radius: 58px;
            color: #fff !important;
            display: inline-block;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc .play-btn-white i {
            background: red;
            height: 56px;
            width: 56px;
            line-height: 56px;
            border-radius: 50%;
            font-size: 26px;
            display: inline-block;
            text-align: center;
            margin-right: 15px;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc .video-btn-white a {
            padding: 1em;
        }

        .Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc .video-btn-white a:hover {
            background-color: white;
            color: black!important;
        }

    </style>
    <div class="Cd9d87317-a57a-3513-4b33-d86a7ec1c3bc" editor-layout="true">
        <section class="section bg-video" style="background-image: url({img})">
            <div class="bg-overlay"></div>
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="text-center">
                            <h3 class="mb-0 text-capitalize text-white">{@html Title}</h3>
                            <div class="main-title-border mx-auto"></div>
                            <p class="text-white sec_subtitle mx-auto mt-2">{@html subTitle}</p>
                        </div>
                    </div>
                </div>
                <div class="row mt-4 pt-4">
                    <div class="col-lg-12">
                        <div class="video-btn-white text-center">
                            <a href="{link}" target="_blank" class="play-btn-white shadow-drop-bl-hover video_play mx-auto">
                               <span>{@html textButton}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</component>
